module.exports = __webpack_public_path__ + "img/logo.2a2df207.svg";